import * as React from "react";
import { Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { TRPCProvider } from "@/providers/TRPCProvider";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { DevToolbar } from "@/components/DevToolbar";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { TooltipProvider } from "@/components/ui/tooltip";

/**
 * Root Layout Component
 *
 * This is the root layout for the entire application.
 * It wraps all pages with:
 * - TRPCProvider: tRPC + React Query context
 * - AuthProvider: Provides authentication context
 * - Toaster: Toast notifications (sonner)
 */
export function RootLayout() {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <ThemeProvider>
      <TRPCProvider>
        <AuthProvider>
          <TooltipProvider delayDuration={300}>
            {/* Main content outlet */}
            <Outlet />

            {/* Floating dev panel (renders only on localhost) */}
            <DevToolbar />

            {/* Global toast notifications */}
            <Toaster position="top-right" richColors closeButton />
          </TooltipProvider>
        </AuthProvider>
      </TRPCProvider>
    </ThemeProvider>
  );
}
